import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
    TextField,
    CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";
import InstagramDateRange from "./InstagramDateRange";
import {
    useGetSocialMediaReportQuery,
} from "../../../../Services/reports/tickets/ReportTickets";


const YoutubeReport = () => {
    const navigate = useNavigate();
    const [localLoading, setLocalLoading] = useState(false);
    const [dataRows, setDataRows] = useState<any[]>([]);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
    });
    const [fromDate, setFromDate] = useState<string>("");
    const [toDate, setToDate] = useState<string>("");
    const [params, setParams] = useState<any>(null);

    const {
        data: socialMediaReportData,
        status: socialMediaReportStatus
    } = useGetSocialMediaReportQuery(params, {
        skip: !params,
    });


    // Helper to format date as dd-mm-yyyy
    const formatDisplayDate = (dateStr: string) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr; // fallback if not valid
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Columns for media_insights
    const columns: GridColDef[] = [
        { field: "title", headerName: "Title", flex: 1.5, align: 'center', headerAlign: 'center' },
        {
            field: "video_url",
            headerName: "Video url",
            flex: 2,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: any) => (
                <a href={params.value} target="_blank" rel="noopener noreferrer">{params.value}</a>
            ),
        },
        { field: "tickets_raised", headerName: "Ticket raised", flex: 1, align: 'center', headerAlign: 'center' },
        { field: "positive_count", headerName: "Positive count", flex: 1, align: 'center', headerAlign: 'center' },
        { field: "negative_count", headerName: "Negative count", flex: 1, align: 'center', headerAlign: 'center' },
        { field: "likes", headerName: "Likes", flex: 1, align: 'center', headerAlign: 'center' },
        { field: "comments", headerName: "Comments", flex: 1, align: 'center', headerAlign: 'center' },
        { field: "views", headerName: "Views", flex: 1, align: 'center', headerAlign: 'center' },
    ];

    useEffect(() => {
        const dropdownHeadings = document.querySelectorAll(".dropdown-heading");
        dropdownHeadings.forEach((heading: any) => {
            heading.style.height = "50px";
        });
    }, []);

    // Map API data to DataGrid rows for media_insights
    useEffect(() => {
        if (
            socialMediaReportData &&
            Array.isArray(socialMediaReportData.data) &&
            socialMediaReportData.data[0] &&
            Array.isArray(socialMediaReportData.data[0].media_insights)
        ) {
            const insights = socialMediaReportData.data[0].media_insights.map((item: any, idx: number) => ({ id: idx + 1, ...item }));
            setDataRows(insights);
        } else {
            setDataRows([]);
        }
    }, [socialMediaReportData]);

    useEffect(() => {
        if (socialMediaReportStatus === "pending") {
            setLocalLoading(true);
        } else {
            setLocalLoading(false);
        }
    }, [socialMediaReportStatus]);

    // Download CSV function
    const handleDownloadCSV = () => {
        if (!dataRows.length) return;
        // Prepare headers from columns
        const headers = columns.map(col => col.headerName).join(",");
        // Prepare rows
        const csvRows = dataRows.map(row =>
            columns.map(col => {
                let value = row[col.field];
                // Escape quotes
                if (typeof value === 'string') value = '"' + value.replace(/"/g, '""') + '"';
                return value !== undefined ? value : '';
            }).join(",")
        );
        const csvContent = [headers, ...csvRows].join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'youtube_report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    useEffect(() => {
        if (!fromDate || !toDate) return;
        setParams({
            from_date: fromDate,
            to_date: toDate,
            platform: "youtube",
        });
    }, [fromDate, toDate]);

    useEffect(() => {
        if (params) {
            setLocalLoading(true);
            // Add logic from handleSubmit here
            // For now, just log the params
            console.log("Fetching data with params:", params);
            // You can add API call or other logic here
            setTimeout(() => {
                setLocalLoading(false);
            }, 1000);
        }
    }, [params]);

    console.log("socialMediaReportData", socialMediaReportData)
    // Extract header data safely
    const statsHeader = socialMediaReportData && Array.isArray(socialMediaReportData.data) && socialMediaReportData.data[0] &&
        Array.isArray(socialMediaReportData.data[0].media_insights) && socialMediaReportData.data[0].media_insights[0]
        ? socialMediaReportData.data[0].media_insights[0]
        : null;

    return (
        <div>

            <div id="kt_app_content_container" className="app-container mx-5">
                <div className="card card-flush" style={{ width: "100%" }}>

                    {/* Card Header */}
                    <div className="card-header align-items-center py-1 gap-2 gap-md-5" style={{ justifyContent: 'flex-start' }}>
                        {/* Back button */}
                        <button
                            className="btn btn-link mb-2"
                            onClick={() => {
                                navigate("/reports/report-social-media/reports-list");
                            }}
                            style={{ marginRight: "-17px" }}
                        >
                            <i className="bi bi-arrow-90deg-left" style={{
                                fontSize: "20px",
                                color: "black",
                                cursor: "pointer",
                            }}></i>
                        </button>
                        <span className="fs-3 text-gray-800 fw-bold ms-3"> Youtube </span>
                    </div>

                    {/* Toolbar */}
                    <div className="card-toolbar flex-row-fluid justify-content-start gap-5 d-flex mb-10" style={{ marginLeft: "30px" }}>
                        {/* Date Filters */}
                        {/* Date Filter */}
                        <div className="d-flex gap-3 align-items-end">
                            {/* Use the new InstagramDateRange component for date selection */}
                            <InstagramDateRange onDateChange={(start, end) => {
                                setFromDate(start);
                                setToDate(end);
                            }} />
                        </div>
                        <div className="ms-auto d-flex gap-3" style={{ marginRight: "20px" }}>
                            <button
                                className="btn btn-primary"
                                style={{ minWidth: "100px", height: "50px", whiteSpace: "nowrap" }}
                                onClick={handleDownloadCSV}
                                disabled={!dataRows.length}
                            >
                                Download
                            </button>
                        </div>
                    </div>

                    {/* DataGrid */}
                    <CardContent style={{ width: "100%" }}>
                        <div style={{ height: 600, width: "100%" }}>
                            {localLoading ? (
                                <LoadingSpinner />
                            ) : (
                                <DataGrid
                                    rows={dataRows}
                                    columns={columns}
                                    loading={localLoading}
                                    disableColumnMenu
                                    hideFooter={true}
                                    sx={{
                                        "& .MuiDataGrid-columnHeader": {
                                            backgroundColor: "lightgray",
                                            "&:last-child": {
                                                justifyContent: "flex-end",
                                            },
                                        },
                                        "& .MuiDataGrid-columnHeaderTitle": {
                                            fontWeight: "bold",
                                        },
                                        "& .MuiDataGrid-columnsContainer": {
                                            backgroundColor: "lightgray",
                                        },
                                        "& .MuiTablePagination-select, .MuiTablePagination-actions": {
                                            marginBottom: "10px",
                                        },
                                        "& .MuiDataGrid-overlayWrapper": {
                                            height: "50px",
                                        },
                                    }}
                                />
                            )}
                        </div>
                    </CardContent>
                </div>
            </div>
        </div>
    );
}

export default YoutubeReport;
